module.exports = __webpack_public_path__ + "img/Group4_english.59acd9b9.jpg";